<template>
  <div>
    <TopMenu :leftOption="'back-dashboard'" :title="$t('Help')"/>
    <div class="view">
      <transition name="fade" appear>
        <div class="container">
          <h1>{{$t('Help')}}</h1>
          <p>E-mail: info@musicbox.com.hr</p>
          <p>{{$t('Phone')}}: +385 99 226 8872</p>
          <p>{{$t('Video tutorial')}}: <a href="https://www.youtube.com/channel/UCmpQzP7878z4skHD7xdS8jw">link</a></p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Help'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Help.vue